


import React from 'react'
import { io } from 'socket.io-client';
import { useState, useRef, useEffect } from 'react';
import imgSucessfull from './../asses/not-found/redicon-removebg-preview.png'
// import imgForHome from './../asses/not-found/logo-home-removebg-preview.png'
import iconoReciclaje from './../asses/not-found/reciclaje-removebg-preview.png'

import soundBoxMoney from './../sounds/Cash_Register_Kashing_-_Sound_Effect_[_YouConvert.net_].mp3'

function Carbuy({ api7, ip1, centralApi, setConsoleAdmin, englishActivate, consoleAdmin, setVisibilityCar, numberSameProduct, setNumberBurgers, numberBurgers, setProductCuantity, productCuantity, setNumberOrders, alert, numberOrders, orderSucessFull, setOrderSucessFull, setTotalPay, tableNumber, buy, setBuy, setProductsToCar, totalPay, productsTocar }) {
    const [messageSocket, setMessageSocket] = useState(null)
    const [errorSocket, setErrorSocket] = useState(null)
    const [visibilityFunctionConfirmation, setVisibilityFunctionConfirmation] = useState(false)
    const [alertState, setAlertState] = useState(0)
    const socketRef = useRef()
    const [newSound, setNewSound] = useState(0)


    // SONIDO

    // SOUND

    useEffect(() => {

        const audio = new Audio(soundBoxMoney); // Ruta correcta si el archivo está en la carpeta public
        audio.play().catch(error => {
            console.error("Error al reproducir el sonido:", error);
        })
    }, [newSound]);

    // CONTROL DE PEDIDOS

    let theconeccction = 0
//   const centralApi = "https://apicentral-67bm.onrender.com"
const restaurantName = "Burger shop"
const increaseConnections = async () => {
// theconeccction = theconeccction + 1
// if(theconeccction === 1){
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ restaurantName })
  };

  try {
    const response = await fetch(`${centralApi}/api/increase/pedidos`, config);
    const data = await response.json();

    if (response.ok) {
      console.log("Solicitud enviada con éxito:", data);
    } else {
      console.error("Error en la respuesta:", data);
    }
  } catch (err) {
    console.error("No se pudo enviar la solicitud ---->", err);
  }
// }
};

useEffect(() => {
console.log("ESTRUCTURA PRODUCTSTOCAR -----> " + JSON.stringify(productsTocar))
}, [productsTocar])

const [ip, setIp] = useState('');
const correctIp = "190.151.204.236"
const [incorrectIp, setIncorrectIp] = useState("")
const [blokedSendButton, setBlokedSendButton] = useState(false)

useEffect(() => {
  // Realizar la petición a la API de ipify
  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {setIp(data.ip)
        if(ip === ip1){
            setBlokedSendButton(false)
        }
    })
    .catch(error => console.error('Error al obtener la IP:', error));
}, []);


// SIN COMPROBACION DE SEGURIDAD MEDIANTE IP


// const sendOrderToKitchen  = async  (e) => {

//     if(productsTocar.length > 0){
//     e.preventDefault()
//     socketRef.current = io(api1, { path: '/socket' });
//     setBuy({products: productsTocar, table: tableNumber, totalPayOrder: totalPay})
//    setProductsToCar([])

//    setOrderSucessFull(true)
  
//    setTimeout(() => {
// setOrderSucessFull(false)
//    }, 3000)
//   //  console.log("esta es la etructura de producst: " + JSON.stringify(productsTocar) + "esto es lo que esta llegando en table:  " + tableNumber + "y esto es lo que esta llegando en el pago: " + totalPay) 
//    setNumberOrders(numberOrders += 1)
//    setNewSound(newSound + 1)
//     try {
//       await socketRef.current.emit('nuevoPedido', { table: tableNumber, products: productsTocar, totalPayOrder: totalPay });
//       setConsoleAdmin(prevState => [...prevState, 'Pedido enviado al servidor']);
//       // Lógica adicional después de enviar el pedido
//     } catch (error) {
//       setConsoleAdmin(prevState => [...prevState, 'Error al enviar el pedido:', error.message]);
//       setErrorSocket(error.message);
//     }
//     setTotalPay(0)
//     setNumberBurgers(0)}
//     else {
//       setAlertState(alertState + 1)
//     }

//   };



// COMPROBACION DE SEGURIDAD MEDIANTE IP FUNCION


// SEGURIDAD IPS

const [ipClient, setIpClient] = useState()
const [ips, setIps] = useState()

useEffect(() => {
fetch('https://api.ipify.org?format=json').then(res => res.json()).then(data => setIpClient(data.ip))
}, [])

useEffect(() => {
fetch(`${centralApi}/getIps`).then(res => res.json()).then(data => setIps(data))
}, [])

const nameRestaurant = 'Burger shop'

const sendOrderToKitchen  = async  (e) => {
    const nameIp = ips.find((ip) => {
        return ip.nombreRestaurante === nameRestaurant
    })


    if(String(nameIp.ip) === String(ip)){
    if(productsTocar.length > 0){
    e.preventDefault()
    socketRef.current = io(api7, { path: '/socket' });
    setBuy({products: productsTocar, table: tableNumber, totalPayOrder: totalPay})
   setProductsToCar([])

   setOrderSucessFull(true)
  
   setTimeout(() => {
setOrderSucessFull(false)
   }, 3000)
  //  console.log("esta es la etructura de producst: " + JSON.stringify(productsTocar) + "esto es lo que esta llegando en table:  " + tableNumber + "y esto es lo que esta llegando en el pago: " + totalPay) 
   setNumberOrders(numberOrders += 1)
   setNewSound(newSound + 1)
    try {
      await socketRef.current.emit('nuevoPedido', { table: tableNumber, products: productsTocar, totalPayOrder: totalPay });
      setConsoleAdmin(prevState => [...prevState, 'Pedido enviado al servidor']);
      // Lógica adicional después de enviar el pedido
    } catch (error) {
      setConsoleAdmin(prevState => [...prevState, 'Error al enviar el pedido:', error.message]);
      setErrorSocket(error.message);
    }
    setTotalPay(0)
    setNumberBurgers(0)}
    else {
      setAlertState(alertState + 1)
    }
}else if(nameIp.ip !== ip){
   if(englishActivate){
    setIncorrectIp("Need connect from the Ip of the shop.")
    setBlokedSendButton(true)
   }else if(!englishActivate){
    setIncorrectIp("Necesitas conectarte desde la ip del establecimiento.")
setBlokedSendButton(true)   
}
}
};





// const sendOrderToKitchen = async (e) => {




//     if (productsTocar.length > 0) {
//       e.preventDefault();
//       socketRef.current = io(api1, { path: '/socket' });
//       setBuy({ products: productsTocar, table: tableNumber, totalPayOrder: totalPay });
//       setProductsToCar([]);
//       setOrderSucessFull(true);
  
//       setTimeout(() => {
//         setOrderSucessFull(false);
//       }, 3000);
  
//       setNumberOrders(numberOrders + 1);
//       setNewSound(newSound + 1);
  
//       try {
//         await socketRef.current.emit('nuevoPedido', { table: tableNumber, products: productsTocar, totalPayOrder: totalPay });
//         setConsoleAdmin(prevState => [...prevState, 'Pedido enviado al servidor']);
//         // Lógica adicional después de enviar el pedido
//       } catch (error) {
//         setConsoleAdmin(prevState => [...prevState, 'Error al enviar el pedido:', error.message]);
//         setErrorSocket(error.message);
//       }
  
//       setTotalPay(0);
//       setNumberBurgers(0);
//     } else {
//       setAlertState(alertState + 1);
//     }
//   };
  


    const deleteProductFuncion = (id) => {
        // Buscar el producto que se desea eliminar
        const pedidoIdentificado = productsTocar.find((product) => product.id === id);
    
        // Verificar si se encontró el producto
        if (pedidoIdentificado && !isNaN(pedidoIdentificado.price)) {
            // Calcular cuántas veces está presente el producto en el carrito
            const productCount = productsTocar.filter(product => product.id === id).length;
    
            // Calcular el nuevo total y cantidad
            const newToPay = totalPay - (pedidoIdentificado.price * productCount);
            const newNumberBurgers = numberBurgers - productCount;
    
            if (!isNaN(newToPay) && !isNaN(newNumberBurgers)) {
                // Filtrar el producto eliminado
                const filtracion = productsTocar.filter((product) => product.id !== id);
    
                // Actualizar el estado
                setProductsToCar(filtracion);
                setTotalPay(newToPay);
                setNumberBurgers(newNumberBurgers);
            } else {
                console.error("Los cálculos resultaron en NaN.");
            }
        } else {
            console.error(`Producto con id ${id} no encontrado o tiene valores inválidos.`);
        }
    };
         
    useEffect(() => {
        const carbuyContainer = document.getElementById('carbuy-container-id');

        if (carbuyContainer) {
            // Desplazar el scroll del contenedor principal al contenedor de los botones
            carbuyContainer.scrollTop = 0;
        }
    }, [productsTocar]);


    // Función para agrupar productos por nombre y contar su cantidad
    const groupedProducts = productsTocar.reduce((acc, product) => {
        const found = acc.find(p => p.name === product.name);
        if (found) {
            found.count += 1;
        } else {
            acc.push({ ...product, count: 1 });
        }
        return acc;
    }, []);


    return (
        <div className='container-carbuy' id='carbuy-container-id'>

        {incorrectIp && <div
        style={{display: "flex", flexDirection: "column"}}
        >
            {incorrectIp}
         
            </div>}
            <div>
                <button className='primary-button' onClick={() => setVisibilityCar(false)}>X</button>
            </div>
            {!englishActivate && <div className='container-dates-carbuy'>
                <div className='container-titles-carbuy'>
                    <h1 className='count-p'>Cuenta <p className='p-count'>{totalPay}</p></h1>
                </div>
                <div className='container-titles-carbuy'>
                    <h1 className='count-p'>Cantidad <p className='p-count'>{numberBurgers}</p></h1>
                </div>
            </div>}

            {englishActivate && <div className='container-dates-carbuy'>
                <div className='container-titles-carbuy'>
                    <h1 className='count-p'>Account <p className='p-count'>{totalPay}</p></h1>
                </div>
                <div className='container-titles-carbuy'>
                    <h1 className='count-p'>Amount <p className='p-count'>{numberBurgers}</p></h1>
                </div>
            </div>}
            <div className='totalPaiContainer' id='btns-carbuy-container' >
                <div className='container-buttons-carbuy'>
                    <div  >
                        {/* style={{display: "flex", flexDirection: "column"}} */}

              {!blokedSendButton   &&  !englishActivate && <button className='btn-chat-send-2' style={{ marginTop: "5%", marginBottom: "10px" }} onClick={(e) => sendOrderToKitchen(e)}>ENVIAR</button>
                        }
                        {!blokedSendButton &&  englishActivate && <button className='btn-chat-send-2' style={{ marginTop: "5%", marginBottom: "10px" }} onClick={(e) => sendOrderToKitchen(e)}>SEND</button>
                        }
                        {blokedSendButton &&    <button className='wtp-btn'><a href='https://wa.me/3107935885'>Whatssap</a></button>}
                    </div>
                    <div>
                        {/* <h1 style={{color: "white"}}>Detalles</h1> */}
                    </div>
                </div>

                {alert && <div className='order-sucessfull'>
                    <h1 className=' ordersucess-h1'>{alert}</h1>
                </div>}
                {orderSucessFull && <div style={{ backgroundColor: "transparent", width: "100%" }}>
                    <img src={imgSucessfull} style={{ width: "100%", marginLeft: "calc(50% - 50%)" }} />
                </div>
                }

                {groupedProducts && groupedProducts.map((product, index) => (
                    <div key={index} className='container-carbuy-impresion'>
                        <div className='container-impresion-carbuy'>
                            <img className='img-crbuy' src={product.imagen}/>
                            <h2 >{product.count}</h2>
                            <button className='btn-reciclaje' onClick={() => deleteProductFuncion(product.id)}><img src={iconoReciclaje} className='icono-reciclaje' /></button>
                        </div>
                    </div>
                ))}


            </div>
        </div>
    )
}

export default Carbuy
